
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16.5","height":"15.7","viewBox":"0 0 16.5 15.7"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.792 0H5.407A1.707 1.707 0 003.7 1.707V2.7H2.208A2.21 2.21 0 000 4.908v8.585A2.21 2.21 0 002.208 15.7h9.385a2.209 2.209 0 002.207-2.207V12h.992a1.707 1.707 0 001.708-1.707V1.707A1.707 1.707 0 0014.792 0zM12.8 13.493a1.208 1.208 0 01-1.207 1.207H2.208A1.209 1.209 0 011 13.493V4.908A1.209 1.209 0 012.208 3.7H3.7v6.593A1.707 1.707 0 005.407 12H12.8zm.584-5.069a.4.4 0 01-.56.56l-2.483-2.483-2.483 2.483a.4.4 0 01-.56-.56l2.483-2.483-2.483-2.483a.4.4 0 01.56-.56l2.483 2.483 2.483-2.483a.4.4 0 01.56.56l-2.483 2.483z","fill":"#fff"}})])
          )
        }
      }
    